"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcProxy = void 0;
let id = 0;
class RpcProxy {
    constructor({ path, method }) {
        this.path = path;
        this.method = method;
    }
    static getId() {
        return `${++id}:${Math.random().toString(16).slice(2)}`;
    }
    load(payload) {
        const { path, method, request } = this;
        if (!request) {
            throw new Error('RpcProxy error: before load must bee setted context via setContext');
        }
        const data = {
            jsonrpc: '2.0',
            id: RpcProxy.getId(),
            method,
            params: payload !== null && payload !== void 0 ? payload : null
        };
        return request.execute('POST', `/${path}`, data);
    }
    setContext(request) {
        this.request = request;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setParams(params) {
        // no-op
    }
}
exports.RpcProxy = RpcProxy;
//# sourceMappingURL=RpcProxy.js.map